import {
  buoyConditionDetails,
  route,
} from '../../../features/BuoyConditions/config/buoyConditions.config';

export { route };

export const details = buoyConditionDetails;

export const layoutConfig = {
  '1x1': {
    visibleCount: ({ compactVisibleCount }) => compactVisibleCount,
    compactTimeUpdate: true,
    controlsClassName: 'd-flex',
    selectorMode: 'row',
    gridColumnCount: 1,
    selectorHeight: 'clamp(4.25rem, 30%, 4.75rem)',
    selectorGap: 6,
    selectorTileStyle: { padding: '0.25rem 0.35rem' },
    wrapperClassName: 'd-flex h-100 w-100 flex-column overflow-hidden',
    contentClassName: 'd-flex w-100 flex-grow-1 min-h-0 flex-column p-1',
    detailsClassName: 'pt-1 px-1',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(9, (layoutSize?.baseFontSize ?? 12) - 3),
    }),
    detailsIconSize: 13,
    detailGroups: [
      ['windSpeed', 'windDirection'],
      ['waveHeight', 'wavePeriod'],
      ['waterTemperature', 'airTemperature'],
      ['dewPoint', 'barometricPressure'],
      ['visibility'],
    ],
  },

  '1x2': {
    visibleCount: () => 2,
    compactTimeUpdate: false,
    controlsClassName: 'd-flex',
    selectorMode: 'grid',
    gridColumnCount: 1,
    selectorHeight: 'clamp(9.5rem, 38%, 12rem)',
    selectorGap: 6,
    selectorListStyle: {
      gridAutoRows: 'minmax(0, 1fr)',
    },
    selectorTileStyle: { padding: '0.65rem' },
    wrapperClassName: 'd-flex h-100 w-100 flex-column overflow-hidden',
    contentClassName: 'd-flex w-100 flex-grow-1 min-h-0 flex-column p-2',
    detailsClassName: 'pt-2 px-1',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(10, (layoutSize?.baseFontSize ?? 12) - 1),
    }),
    detailsIconSize: 15,
    detailGroups: [
      [
        'windSpeed',
        'windDirection',
        'waveHeight',
        'wavePeriod',
        'waterTemperature',
        'airTemperature',
        'dewPoint',
        'barometricPressure',
        'visibility',
      ],
    ],
  },

  '2x1': {
    visibleCount: () => 4,
    compactTimeUpdate: false,
    controlsClassName: 'd-flex',
    selectorMode: 'row',
    gridColumnCount: 1,
    selectorHeight: 'clamp(4.75rem, 38%, 6.25rem)',
    selectorGap: 8,
    selectorListStyle: { justifyContent: 'center' },
    selectorTileStyle: {
      flex: '0 0 calc((100% - 24px) / 4)',
      padding: '0.45rem',
    },
    wrapperClassName: 'd-flex h-100 w-100 flex-column overflow-hidden',
    contentClassName: 'd-flex w-100 flex-grow-1 min-h-0 flex-column px-2 pb-2',
    detailsClassName: 'pt-2 px-2',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(10, (layoutSize?.baseFontSize ?? 12) - 1),
    }),
    detailsIconSize: 16,
    detailGroups: [
      ['windSpeed', 'windDirection', 'visibility'],
      ['waveHeight', 'wavePeriod', 'waterTemperature'],
      ['airTemperature', 'dewPoint', 'barometricPressure'],
    ],
  },
};
